import React from "react";

export default function Wrapper({ children }) {
  return <div className="bg-white rounded-lg p-5 mx-5 min-h-[400px!important]">{children}</div>;
}
